import { render } from "./FavoriteButton.vue?vue&type=template&id=074caeea&scoped=true"
import script from "./FavoriteButton.vue?vue&type=script&lang=js"
export * from "./FavoriteButton.vue?vue&type=script&lang=js"

import "./FavoriteButton.vue?vue&type=style&index=0&id=074caeea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074caeea"]])

export default __exports__